const FLIGHT_UPDATED = (state, Flight) => {
  state.Flight = Flight
}

const FLIGHTLEGS_UPDATED = (state, flightLegs) => {
  state.flightLegs = flightLegs
}

export default {
  FLIGHT_UPDATED,
  FLIGHTLEGS_UPDATED
}
